
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52.606","height":"8.072"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5.554V8.07a7.679 7.679 0 006.335-3.278 4.972 4.972 0 018.38.045 7.779 7.779 0 0012.658-.045 4.977 4.977 0 018.392.045 7.782 7.782 0 0012.652-.032 5.093 5.093 0 014.19-2.29V-.001a7.627 7.627 0 00-6.292 3.473 5.309 5.309 0 01-8.392.05 7.469 7.469 0 00-12.652-.05 5.309 5.309 0 01-8.392.05A7.476 7.476 0 004.22 3.477a5.114 5.114 0 01-4.2 2.077"}})])
          )
        }
      }
    